<template>
  <a-menu
    rounded
    offset-y
    :close-on-content-click="false"
    dense
    :nudge-width="100"
    nudge-bottom="2"
    v-if="!timerPage"
    v-model="helpMenu"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="tooltipDisabled">
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            small
            color="secondary"
            width="32"
            min-width="32"
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon size="16" class="mr-0"> mdi-help</v-icon>
          </a-btn>
        </template>
        <span>{{ $t("HelpMenu") }}</span>
      </v-tooltip>
    </template>

    <v-list dense :min-width="330">
      <v-list-item
        v-for="(option, index) in helpOptions"
        :key="index"
        @click="onHelpOptionClick(option)"
      >
        <v-icon class="mr-1">{{ option.icon }}</v-icon>
        <span style="margin-left: 5px">{{ option.text }}</span>
      </v-list-item>
    </v-list>
  </a-menu>
</template>

<script>
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
export default {
  components: { AMenu, ABtn },
  name: "Help",
  data() {
    return {
      manualClick: 0,
      licenseClick:0,
      licenseWindow: {},
      manualWindow: {},
      helpMenu: false,
      tooltipDisabled: false,
    };
  },
  watch: {
    helpMenu(newValue) {
      if (newValue) {
        this.tooltipDisabled = true;
      } else {
        this.tooltipDisabled = false;
      }
    },
  },
  computed: {
    timerPage() {
      return (
        this.$route.path.startsWith("/meetingTimer/") ||
        this.$route.path.startsWith("/usermanual") ||
        this.$route.path.startsWith("/licensepolicy")
      );
    },
    helpOptions() {
      return [
        {
          value: "userManual",
          text: this.$t("UserManual"),
          icon: "mdi-account-question",
          href: "/usermanual",
        },
        {
          value: "writeToUs",
          text: this.$t("WriteToUs"),
          icon: "mdi-email-edit-outline",
          href: "mailto:trinityboard@diva.co.jp",
        },
        {
          value: "privacyPolicy",
          text: this.$t("PrivacyPolicy"),
          icon: "mdi-information-outline",
          href: "https://www.diva.co.jp/privacy_policy/",
        },
        {
          value: "licensePolicy",
          text: this.$t("SoftwareLicensePolicy"),
          icon: "mdi-information-outline",
          href: "/licensepolicy",
        },
      ];
    },
  },
  methods: {
    onHelpOptionClick,
    openUserManual,
  },
};

function onHelpOptionClick(option) {
  if (option.value !== "writeToUs") {
    this.openUserManual(option);
  } else {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = option.href;
    a.click();
  }
}

function openUserManual(option) {
  let height = screen.height;
  let width = screen.width;
  let strWindowFeatures =
    "location=no,toolbar=no,menubar=no,height=" +
    height +
    ",width=" +
    width +
    ",scrollbars=auto,fullscreen=yes";

  let routeData;
  if(option.value === "userManual" || option.value === "licensePolicy") {
    routeData = this.$router.resolve({
      path: option.href,
      query: { content: option.value === "userManual" ? 'TRINITY.BOARD.Manual.pdf' : 'Open.Source.Software.License.pdf' },
    });
  }
  else {  
    routeData = this.$router.resolve({
      path: option.href
    });
  }
  let popup;
  if (
    option.value === "userManual" &&
    routeData) {
      this.manualClick += 1;
      if (typeof this.manualWindow === "undefined" ||
        this.manualWindow.closed || this.manualClick === 1) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      }
      else {
        this.manualWindow.focus();
      }
  } 
  else if (option.value === "licensePolicy" &&
    routeData) {
      this.licenseClick += 1;
      if (typeof this.licenseWindow === "undefined" ||
        this.licenseWindow.closed || this.licenseClick === 1) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.licenseWindow = popup;
        popup.moveTo(0, 0);
      }
      else {
        this.licenseWindow.focus();
      }
  } 
  else {
    popup = window.open(option.href, "_blank", strWindowFeatures);
  }
}
</script>
